import React from "react";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "../../components/layout";
import HeaderTwo from "../../components/header/header-two";
import StickyHeader from "../../components/header/sticky-header";
import PageHeader from "../../components/page-header";
import ZgbPage from "../../components/team/zgb-page";
import Footer from "../../components/footer";
import LoadingContent from "../../components/loading-content-1";
import NoRecordsContent from "../../components/no-records-content";

import Select from "react-select";

var Api_url = process.env.GATSBY_API_URL;
console.log("API_URL=" + Api_url);

const axiosConfig = {
    headers: {
        "Content-Type": "application/json; text/html; charset=UTF-8",
        "Access-Control-Allow-Origin": "*"
    }
};

// const Volunteers = () => {
class NomCoordinator extends React.Component {
    constructor() {
        super();
        this.state = {
            members: [],
            isClearable1: true,
            isDisabled1: false,
            isLoading1: false,
            isSearchable1: true,
            TeamOptions: [],
            TeamId: 2,
            TeamName: "",
            LoadingFlag: false,
            TotalRecords: 0,
        };
    }

    getAllRecords = async () => {
        console.log("fetchData called ");
        var url = Api_url + `/api/wm/yearwise/team/members/lists`;
        console.log("url=" + url );
        var postData = {
            UserInterface: 1,
            YearCode: 68,
            LomCode: 3,
            TeamCode: 23,
        };
        console.log("postData=" + JSON.stringify(postData));
        this.setState({ LoadingFlag: true });
        await axios
            .post(url, postData, axiosConfig)
            .then(res => {
                console.log("RESPONSE RECEIVED: ", res);
                console.log("res=" + JSON.stringify(res));
                var result = res.data.records;
                var n1 = result.length;
                console.log("n1=" + n1);
                console.log("result=" + JSON.stringify(result));
                var TeamName = res.data.team_name;
                this.setState({ LoadingFlag: false, TotalRecords: n1, members: result, TeamName: TeamName });
            })
            .catch(err => {
                console.log("AXIOS ERROR: ", err);
            });
    };

    componentDidMount() {
        console.log("componentDidMount called ");
        this.getAllRecords();
    }
    render() {
        return (
            <Layout pageTitle="NOM Coordinator | JCI India">
                <HeaderTwo />
                <StickyHeader />
                <PageHeader title="NOM Coordinator" crumbTitle="Team" />
                {this.state.LoadingFlag ? <LoadingContent /> : ''}
                {this.state.LoadingFlag ? '' :
                    (this.state.TotalRecords > 0 ?
                        <ZgbPage members={this.state.members} />
                        : <NoRecordsContent />
                    )
                }
                <Footer />
            </Layout>
        );
    }
}

export default NomCoordinator;
